import React from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonial = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero quasi deleniti ratione similique eaque blanditiis fugit voluptas ex officiis expedita repellat doloribus veniam delectus tempore, laudantium, aliquam ad? Rem, accusantium?",
      image: "../img/testimonial-1.jpg",
      name: "Client Name",
      profession: "Profession",
      rating: 4
    },
    {
      id: 2,
      quote: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero quasi deleniti ratione similique eaque blanditiis fugit voluptas ex officiis expedita repellat doloribus veniam delectus tempore, laudantium, aliquam ad? Rem, accusantium?",
      image: "img/testimonial-2.jpg",
      name: "Client Name",
      profession: "Profession",
      rating: 4
    },
    {
      id: 3,
      quote: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero quasi deleniti ratione similique eaque blanditiis fugit voluptas ex officiis expedita repellat doloribus veniam delectus tempore, laudantium, aliquam ad? Rem, accusantium?",
      image: "img/testimonial-3.jpg",
      name: "Client Name",
      profession: "Profession",
      rating: 4
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} slick-next`}
        style={{ ...style, right: '-50px', zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} slick-prev`}
        style={{ ...style, left: '-50px', zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  return (
    <div className="container-fluid testimonial bg-dark py-5" style={{ marginBottom: '90px' }}>
      <div className="container py-5">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: '800px' }}>
          <h4 className="text-primary">Testimonial</h4>
          <h1 className="display-4 text-white">What Our Customers Are Saying</h1>
        </div>

        <div className="testimonial-carousel">
          <Slider {...settings}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-item mx-auto" style={{ maxWidth: '900px' }}>
                <FaQuoteLeft className="quote-icon" style={{ fontSize: '3rem', color: '#ffffff80' }} />
                <div className="testimonial-img mb-4">
                  <img src={testimonial.image} className="img-fluid rounded-circle" alt="Client" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                </div>
                <p className="fs-4 text-white mb-4">{testimonial.quote}</p>
                <div className="d-block">
                  <h4 className="text-white">{testimonial.name}</h4>
                  <p className="m-0 pb-3 text-muted">{testimonial.profession}</p>
                  <div className="d-flex justify-content-center">
                    {[...Array(5)].map((_, i) => (
                      <FaStar 
                        key={i} 
                        className={i < testimonial.rating ? "text-primary" : "text-white"} 
                        style={{ margin: '0 2px' }} 
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;